import { SYS_ID_MODES } from './sysIdMode';

// Deleting a location is expressed as removing every switch row, so the
// decision has to read the rows themselves.
//
// It used to read the number-of-switches input instead. Typing 0 there does not
// clear the rows — areSwitchRowCountsUsable rejects a switch count of 0, so the
// resize effect never runs — yet the counter alone was enough to route Save at
// the delete request. updateSysIdentificationData then built the payload from
// the rows that were still in state: uos_panels full, uos_delete empty. The
// location vanished locally and came back on the next refetch, because nothing
// had actually been deleted.
//
// switches is flat before confirm and nested one array per UOS group after it,
// so flatten before counting.
export const shouldDeleteLocation = (switches, sysIdMode) =>
  sysIdMode === SYS_ID_MODES.EDIT &&
  (switches ?? []).flat().filter(Boolean).length === 0;

